import { InjectionToken } from '@angular/core';

export type FeatureFlags = {
  pathToRegister: boolean;
  showDiscountBanner: boolean;
};

export type UrlsConfig = {
  userAccountUrl: string;
  registrationUrl: string;
  termsUrl: string;
  privacyPolicyUrl: string;
};

export type AuthContextConfig = UrlsConfig & {
  captchaSiteKey: string;
  googleAuthClientId: string;
  oneTapLoginEnabled?: boolean;
  featureFlags: FeatureFlags;
};

export const AUTH_CONTEXT_CONFIG = new InjectionToken<AuthContextConfig>('AUTH_CONTEXT_CONFIG');

export function provideAuthConfig(config: AuthContextConfig) {
  return { provide: AUTH_CONTEXT_CONFIG, useValue: config };
}
